import { useState } from "react";

import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useUIStore } from "@/store/uiStore";

export function ThemeSwitcher() {
  const { t } = useTranslation();
  const { themeMode, setThemeMode } = useUIStore();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const icon =
    themeMode === "dark" ? <DarkModeIcon /> :
    themeMode === "light" ? <LightModeIcon /> :
    <SettingsBrightnessIcon />;

  return (
    <>
      <Tooltip title={t("theme.label")}>
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          aria-label={t("theme.label")}
          color="inherit"
        >
          {icon}
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {(["auto", "light", "dark"] as const).map((mode) => (
          <MenuItem
            key={mode}
            selected={themeMode === mode}
            onClick={() => {
              setThemeMode(mode);
              setAnchorEl(null);
            }}
          >
            <ListItemIcon>
              {mode === "auto" ? <SettingsBrightnessIcon fontSize="small" /> :
               mode === "light" ? <LightModeIcon fontSize="small" /> :
               <DarkModeIcon fontSize="small" />}
            </ListItemIcon>
            <ListItemText>{t(`theme.${mode}`)}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
